import React from 'react';
import tecnm from '../images/tecnm.jpg';
import tecvalles from '../images/logoitcv.png';
import ipicyt from '../images/ipicyt.jpg';
function Contact() {

  return (
    <>
    <div className='hero-container' >      
      <h1>contacto</h1>
    </div>
    <div className="container">
    <div className="row">
        <h5><center><a href='mailto:hugo.larraga@tecvalles.mx'>hugo.larraga@tecvalles.mx</a></center></h5>
        </div>
        <div className="row">
            <div className="col-sm">
                <div className="card">
                    <center>
                    <a href='https://www.tecnm.mx/' target='_blank' rel="noreferrer">
                        <img className="card-img-top" src={tecnm} alt="Tec NM" style={{width: '50%',}} />
                    </a>
                    <div className="card-body">
                        <h5 className="card-title">Tecnológico Nacional de México</h5>
                    </div>
                    </center>
                </div>
             </div>
            <div className="col-sm">
                <div className="card">
                    <center>
                    <a href='https://www.tecvalles.mx/wp/' target='_blank' rel="noreferrer">
                        <img className="card-img-top" src={tecvalles} alt="Tec Valles" style={{width: '50%',}} />
                    </a>
                    <div className="card-body">
                        <h5 className="card-title">Campus Ciudad Valles</h5>
                    </div>
                    </center>
                </div> 
            </div>
            <div className="col-sm">
                <div className="card">
                    <center>
                    <a href='https://www.ipicyt.edu.mx/' target='_blank' rel="noreferrer">
                        <img className="card-img-top" src={ipicyt} alt="Ipicyt" style={{width: '50%',}} />
                    </a>
                    <div className="card-body">
                        <h5 className="card-title">Instituto Potosino de Investigación Científica y Tecnológica</h5>                       
                    </div>
                    </center>
                </div> 
            </div>
        </div>

    </div>    
    </>
  );
}

export default Contact;